import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { ReactiveFormsModule } from '@angular/forms';
import { BlockCheckboxComponent } from '@app/components/blocks/block-checkbox/block-checkbox.component';
import { PlCheckboxModule } from '@app/components/pl-checkbox/pl-checkbox.module';

@NgModule({
  imports: [CommonModule, SharedModule, ReactiveFormsModule, PlCheckboxModule],
  declarations: [BlockCheckboxComponent],
  exports: [BlockCheckboxComponent],
})
export class BlockCheckboxModule {}
